<template>
  <v-dialog
    v-model="isOpenModalComparaison"
    :scrim="false"
    :fullscreen="$vuetify.breakpoint.mobile"
    :width="$vuetify.breakpoint.mobile ? '' : widthModaleGraphe"
    @click:outside="onClose"
  >
    <v-card class="left-vertical-card px-6">
      <div class="d-flex bg-titre">
        <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
          {{ titre }}
        </div>
        <v-btn
          class="align-self-center"
          text
          @click="onClose"
        >
          <v-icon color="secondary">
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <BaseErrorMessage
        v-if="erreur.updateFiltres"
        message="Erreur serveur. merci de réessayer plus tard."
      />
      <v-row
        no-gutters
      >
        <v-col
          class="px-3 pb-6"
          cols="12"
          md="4"
          @click="onAnyClickFiltres"
        >
          <AgrialSelect
            v-model="regionAgrialSelected"
            :class="regionAgrialSelected.length > 1 ? 'input-multiple' : 'pt-1'"
            :clearable="abonnements.culturialAbonne"
            :menu-props="{ top: true, offsetY: true }"
            :disabled="loading.updateFiltres"
            :items="filtresValeursPossibles.regionsAgrial"
            :readonly="!abonnements.culturialAbonne"
            item-text="libelle"
            label="Régions Agrial"
            multiple
            hide-details
            return-object
            @change="updateFiltresAdherent"
          >
            <template
              v-if="!abonnements.culturialAbonne"
              v-slot:prepend-inner
            >
              <v-icon
                class="prepend-icon"
                color="var(--gris-clair)"
                size="18"
              >
                mdi-lock
              </v-icon>
            </template>
          </AgrialSelect>
          <div
            v-if="regionAgrialSelected.length<1"
            class="pl-1 red--text"
          >
            Au moins une région doit être sélectionnée
          </div>
        </v-col>
        <v-col
          v-if="$vuetify.breakpoint.mobile && regionAgrialSelected.length>=3"
          cols="auto"
          class="mb-5 px-3"
        >
          <BaseMessageV2 message="Plus le nombre de régions sélectionnées est élevé, plus le chargement des comparaisons est long" />
        </v-col>
        <v-col
          class="px-3"
          cols="12"
          md="4"
          @click="onAnyClickFiltres"
        >
          <AgrialSelect
            v-model="typeProductionSelected"
            :disabled="loading.updateFiltres"
            :items="filtresValeursPossibles.typeProduction"
            :readonly="!abonnements.culturialAbonne"
            item-text="libelle"
            label="Type de production"
            return-object
            class="pt-1"
            @change="updateFiltresAdherent"
          >
            <template
              v-if="!abonnements.culturialAbonne"
              v-slot:prepend-inner
            >
              <v-icon
                class="prepend-icon"
                color="var(--gris-clair)"
                size="18"
              >
                mdi-lock
              </v-icon>
            </template>
          </AgrialSelect>
        </v-col>
        <v-col
          class="px-3"
          cols="12"
          md="4"
          @click="onAnyClickFiltres"
        >
          <AgrialSelect
            v-model="stockeurSelected"
            :disabled="loading.updateFiltres"
            :items="filtresValeursPossibles.stockeur"
            :readonly="!abonnements.culturialAbonne"
            item-text="libelle"
            label="Stockeur"
            return-object
            class="pt-1"
            @change="updateFiltresAdherent"
          >
            <template
              v-if="!abonnements.culturialAbonne"
              v-slot:prepend-inner
            >
              <v-icon
                class="prepend-icon"
                color="var(--gris-clair)"
                size="18"
              >
                mdi-lock
              </v-icon>
            </template>
          </AgrialSelect>
        </v-col>
      </v-row>
      <v-row
        v-if="!$vuetify.breakpoint.mobile"
        no-gutters
      >
        <v-col
          v-if="regionAgrialSelected.length>=3"
          cols="auto"
          class="mb-5 px-3"
        >
          <BaseMessageV2 message="Plus le nombre de régions sélectionnées est élevé, plus le chargement des comparaisons est long" />
        </v-col>
      </v-row>
      <BaseLoader v-if="loadingGlobal" />
      <v-row
        v-if="!loadingGlobal && !erreur.grainesRs3 && listeAnneesRecoltes != null && listeAnneesRecoltes.length"
        no-gutters
        class="justify-center px-2"
      >
        <v-col
          v-if="hasDonneesRepartitionVente"
          cols="12"
          class="pa-2"
          :md="mdModaleGraphe"
        >
          <RepartitionVentes
            :loading-adherent="loading.repartitionAdherent"
            :loading-groupe="loading.repartitionGroupe"
            :has-region-selected="regionAgrialSelected.length>0"
            :erreur-adherent="erreur.repartitionAdherent"
            :erreur-groupe="erreur.repartitionGroupe"
          />
        </v-col>
        <v-col
          v-if="hasPrixContratMoyensPourGraineSelectionne"
          cols="12"
          class="pa-2"
          :md="mdModaleGraphe"
        >
          <JaugePrixMoyens
            :affichage-aide-prix-contrat="true"
            :class="$vuetify.breakpoint.mobile ? 'mb-2' : 'mr-2'"
            :erreur="erreur.repartitionPrixContratMoyens"
            :loading="loadingGlobal"
            :has-region-selected="regionAgrialSelected.length>0"
            :repartition-prix="repartitionPrixContratMoyens"
            has-help
            titre="Mon prix de contrat moyen"
          />
        </v-col>
        <v-col
          v-if="hasPrixVenteMoyensPourGraineSelectionne"
          cols="12"
          class="pa-2"
          :md="mdModaleGraphe"
        >
          <JaugePrixMoyens
            :annee-recolte="anneeSelected"
            :erreur="erreur.repartitionPrixVenteMoyens"
            :loading="loadingGlobal"
            :has-region-selected="regionAgrialSelected.length>0"
            :repartition-prix="repartitionPrixVenteMoyens"
            has-help
            titre="Mon prix payé moyen"
          />
        </v-col>
        <v-col
          v-if="hasDonneesEvolutionRendement"
          cols="12"
          class="pa-2"
          :md="mdModaleGraphe"
        >
          <EvolutionPrixContratPrixFerme
            :loading-adherent="loading.evolutionRendement"
            :loading-groupe="loading.evolutionRendement"
            :erreur-adherent="erreur.evolutionRendement"
            :erreur-groupe="erreur.evolutionRendement"
            :has-region-selected="regionAgrialSelected.length>0"
          />
        </v-col>
        <v-col
          v-if="hasDonneesEvolutionPrixcontratGestionDeleguee"
          class="pa-1"
          cols="12"
          :md="countNbGraphes === 3 ? '4' : (countNbGraphes === 2 || countNbGraphes === 4) ? '6' : '12'"
        >
          <EvolutionPrixContratPrixGestionDeleguee
            :loading="loading.evolutionPrixContratGestionDeleguee"
            :erreur="erreur.evolutionPrixContratGestionDeleguee"
          />
        </v-col>
      </v-row>
      <v-card
        v-if="!loadingGlobal && !erreur.grainesRs3 && listeAnneesRecoltes.length && !hasDonneesRepartitionVente && !hasPrixContratMoyensPourGraineSelectionne && !hasPrixVenteMoyensPourGraineSelectionne && !hasDonneesEvolutionRendement && !hasDonneesEvolutionPrixcontratGestionDeleguee"
        class="d-flex
          align-center
          flex-column pb-6"
      >
        <img
          alt="no-comparaison"
          class="mt-5"
          src="@/assets/no-comparaison.svg"
        >
        <div
          :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          class=" d-flex flex-column intro texte-gris-fonce  mt-2 text-justify mx-5"
        >
          <span class="text-center">Pas de comparaison disponible pour cette graine et cette récolte.</span>
        </div>
      </v-card>
      <div class="d-flex justify-center py-3 mt-3">
        <AgrButton
          class="pa-5 branche"
          @click="onPageOutilsAnalyse()"
        >
          Voir ma synthèse
        </AgrButton>
      </div>
      <div
        class="d-flex justify-center asterix mt-3 pb-16 pb-md-3"
      >
        * Evolution par rapport à l’année précédente
      </div>
      <InformationAbonnementModal
        v-if="isOpenModalInformationAbonnement"
        :is-open-modal-information-abonnement="isOpenModalInformationAbonnement"
        code-feature="FILTRE_COMPARAISON"
        texte="Affinez vos comparaisons en choisissant le type d'exploitation avec lequel vous souhaitez vous comparer."
        titre="Filtres de comparaison"
        @close="isOpenModalInformationAbonnement = false"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {AgrButton} from '@agrial/ui'
import AgrialSelect from '@/components/form/agrial-select.vue'
import BaseErrorMessage from '@/components/common/base-error-message.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageV2 from '@/components/common/base-message-v2.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import EvolutionPrixContratPrixFerme from '../evolution-prix-contrat-prix-ferme.vue'
import EvolutionPrixContratPrixGestionDeleguee from '../evolution-prix-contrat-prix-gestion-deleguee.vue'
import JaugePrixMoyens from '../jauge-prix-moyens.vue'
import RepartitionVentes from '../../repartition-ventes.vue'


export default {
  name: 'ComparaisonContratsModal',
  components: {AgrButton, AgrialSelect, BaseErrorMessage, BaseLoader, BaseMessageV2, EvolutionPrixContratPrixFerme, EvolutionPrixContratPrixGestionDeleguee, InformationAbonnementModal,JaugePrixMoyens, RepartitionVentes},
  props: {
    titre: {
      type: String,
      default: null
    },
    isOpenModalComparaison: {
      type: Boolean,
      default: false
    },
    anneeSelected: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      loading: {
        repartitionPrixContratMoyens: false,
        repartitionPrixVenteMoyens: false,
        repartitionAdherent: false,
        repartitionGroupe: false,
        evolutionRendement: false,
        evolutionPrixContratGestionDeleguee:false,
        grainesRs3: false,
        updateFiltres: false,
      },
      erreur: {
        repartitionPrixContratMoyens: false,
        repartitionPrixVenteMoyens: false,
        repartitionAdherent: false,
        repartitionGroupe: false,
        evolutionRendement: false,
        evolutionPrixContratGestionDeleguee:false,
        grainesRs3: false,
        updateFiltres: false,
      },
      
      regionAgrialSelected: null,
      typeExploitationSelected: null,
      typeProductionSelected: null,
      potentielSolSelected: null,
      ressourceEffluentSelected: null,
      stockeurSelected: null,
      isOpenModalInformationAbonnement: false,
    }
  },

  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements',
      repartitionPrixContratMoyens: 'contrat/repartitionPrixContratMoyens',
      repartitionPrixVenteMoyens: 'contrat/repartitionPrixVenteMoyens',
      repartitionQuantiteCibleAdherent: 'contrat/repartitionQuantiteCibleAdherent',
      repartitionQuantiteCibleGroupe: 'contrat/repartitionQuantiteCibleGroupe',
      evolutionPrixContratNumtiers: 'contrat/evolutionPrixContratNumtiers',
      evolutionPrixContratGroupe: 'contrat/evolutionPrixContratGroupe',
      evolutionPrixContratGestionDeleguee: 'prix/evolutionPrixContratGestionDeleguee',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      filtresValeursPossibles: 'filtresComparaison/filtresValeursPossibles',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive',
      listeAnneesRecoltes: 'recolte/listeAnneesRecoltes'
    }),
    loadingGlobal () {
      return this.loading.grainesRs3 || this.loading.repartitionPrixContratMoyens || this.loading.repartitionPrixVenteMoyens  || this.loading.repartitionAdherent  || this.loading.evolutionRendement || this.loading.evolutionPrixContratGestionDeleguee
    },
    valeurPrixVenteMoyenDuNumtiers () {
      return this.repartitionPrixVenteMoyens.positionPersoDuNumtiers && this.repartitionPrixVenteMoyens.positionPersoDuNumtiers.valeur ? this.repartitionPrixVenteMoyens.positionPersoDuNumtiers.valeur : null
    },
    valeurPrixContratDuNumtiers () {
      return this.repartitionPrixContratMoyens.positionPersoDuNumtiers && this.repartitionPrixContratMoyens.positionPersoDuNumtiers.valeur ? this.repartitionPrixContratMoyens.positionPersoDuNumtiers.valeur : null
    },
    hasPrixVenteMoyensPourGraineSelectionne () {
      return this.codeGraineActive && this.valeurPrixVenteMoyenDuNumtiers && this.valeurPrixVenteMoyenDuNumtiers > 0
    },
    hasPrixContratMoyensPourGraineSelectionne () {
      return this.codeGraineActive && this.valeurPrixContratDuNumtiers && this.valeurPrixContratDuNumtiers > 0
    },
    hasDonneeAdherentPrixFermeRepartitionVente () {
      return !!this.repartitionQuantiteCibleAdherent?.quantiteContractualiseePrixFermeEnPourcentage
    },
    hasDonneeAdherentGestionDelegueeRepartitionVente () {
      return !!this.repartitionQuantiteCibleAdherent?.quantiteContractualiseeGestionDelegueeEnPourcentage
    },
    hasDonneeAdherentAutresRepartitionVente () {
      return !!this.repartitionQuantiteCibleAdherent?.quantiteContractualiseeAutresContratsEnPourcentage
    },
    hasDonneeAdherentRepartitionVente () {
      return this.hasDonneeAdherentPrixFermeRepartitionVente || this.hasDonneeAdherentGestionDelegueeRepartitionVente || this.hasDonneeAdherentAutresRepartitionVente
    },
    hasDonneeGroupePrixFermeRepartitionVente () {
      return !!this.repartitionQuantiteCibleGroupe?.quantiteContractualiseePrixFermeEnPourcentage
    },
    hasDonneeGroupeGestionDelegueeRepartitionVente () {
      return !!this.repartitionQuantiteCibleGroupe?.quantiteContractualiseeGestionDelegueeEnPourcentage
    },
    hasDonneeGroupeAutresRepartitionVente () {
      return !!this.repartitionQuantiteCibleGroupe?.quantiteContractualiseeAutresContratsEnPourcentage
    },
    hasDonneeGroupeRepartitionVente () {
      return this.repartitionQuantiteCibleGroupe.nbAdherents > 0 &&
        (this.hasDonneeGroupePrixFermeRepartitionVente || this.hasDonneeGroupeGestionDelegueeRepartitionVente || this.hasDonneeGroupeAutresRepartitionVente)
    },
    hasDonneesRepartitionVente () {
      return this.hasDonneeAdherentRepartitionVente || this.hasDonneeGroupeRepartitionVente
    },
    hasDonneesEvolutionRendementNumtiers () {
      return this.evolutionPrixContratNumtiers.length
        ? this.evolutionPrixContratNumtiers.map(e => e.prixContrat).filter(f => f != null).length > 0
        : false
    },
    hasDonneesEvolutionRendementGroupe () {
      return this.evolutionPrixContratGroupe.prixContratAnnuelsGroupe!= null && this.evolutionPrixContratGroupe.length
        ? this.evolutionPrixContratGroupe.prixContratAnnuelsGroupe.map(e => e.prixContratAnnuel.prixContrat).filter(f => f != null).length > 0
        : false
    },
    hasDonneesEvolutionRendement () {
      return this.hasDonneesEvolutionRendementNumtiers || this.hasDonneesEvolutionRendementGroupe
    },
    hasDonneesEvolutionPrixcontratGestionDeleguee () {
      if (this.loading.evolutionPrixContratGestionDeleguee) {
        return false
      } else {
        return this.evolutionPrixContratGestionDeleguee.primePrixCampagneParAnnee!= null && Object.values(this.evolutionPrixContratGestionDeleguee.primePrixCampagneParAnnee).length
          || this.evolutionPrixContratGestionDeleguee.primeSeptAvrilParAnnee!= null && Object.values(this.evolutionPrixContratGestionDeleguee.primeSeptAvrilParAnnee).length
          || this.evolutionPrixContratGestionDeleguee.primeQuintoParAnnee!= null && Object.values(this.evolutionPrixContratGestionDeleguee.primeQuintoParAnnee).length
      }
    },
    countNbGraphes () {
      let result = 0
      if (this.hasDonneesRepartitionVente) {
        result++
      }
      if (this.hasPrixContratMoyensPourGraineSelectionne) {
        result++
      }
      if (this.hasPrixVenteMoyensPourGraineSelectionne) {
        result++
      }
      if (this.hasDonneesEvolutionRendement) {
        result++
      }
      if (this.hasDonneesEvolutionPrixcontratGestionDeleguee) {
        result++
      }
      return result
    },
    widthModaleGraphe () {
      let result = 0
      if (this.countNbGraphes === 1 || this.countNbGraphes === 2 || this.countNbGraphes === 4) {
        result = '50%'
      } else {
        result = '60%'
      }
      return result
    },
    mdModaleGraphe () {
      let result = 0
      if (this.countNbGraphes === 1) {
        result = 12
      }
      else if (this.countNbGraphes === 2 || this.countNbGraphes === 4 || this.countNbGraphes === 5) {
        result = 6
      } else {
        result = 4
      }
      return result
    }

  },

  created () {
    this.resetAllSelects()
    this.fetchAbonnements()
    this.loadGraphes()
  },

  methods: {
    ...mapActions({
      fetchAbonnements: 'adherent/fetchAbonnements',
      getRepartitionQuantiteCibleContratAdherent: 'contrat/getRepartitionQuantiteCibleContratAdherent',
      getRepartitionQuantiteCibleContratGroupe: 'contrat/getRepartitionQuantiteCibleContratGroupe',
      getPrixContratMoyenComparaison: 'contrat/getPrixContratMoyenComparaison',
      getPrixVenteMoyenComparaison: 'contrat/getPrixVenteMoyenComparaison',
      getEvolutionPrixContratNumtiers: 'contrat/getEvolutionPrixContratNumtiers',
      getEvolutionPrixContratGroupe: 'contrat/getEvolutionPrixContratGroupe',
      getEvolutionPrixContratGestionDeleguee: 'prix/getEvolutionPrixContratGestionDeleguee',
      incrementerAccesSouscriptionAbonnement: 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement',
      setFiltres: 'filtresComparaison/setFiltres'
    }),
    resetAllSelects () {
      this.typeExploitationSelected = this.filtresAdherent.typeExploitation
      this.typeProductionSelected = this.filtresAdherent.typeProduction
      this.potentielSolSelected = this.filtresAdherent.potentielSol
      this.ressourceEffluentSelected = this.filtresAdherent.ressourceEffluents
      this.stockeurSelected = this.filtresAdherent.stockeur
      this.regionAgrialSelected = this.filtresAdherent.regionsAgrial
    },
    updateFiltresAdherent () {
      this.loading.updateFiltres = true
      this.erreur.updateFiltres = false

      const filtresAUpdate = {
        typeExploitation: this.typeExploitationSelected,
        typeProduction: this.typeProductionSelected,
        potentielSol: this.potentielSolSelected,
        ressourceEffluents: this.ressourceEffluentSelected,
        stockeur: this.stockeurSelected,
        regionsAgrial: this.regionAgrialSelected
      }
      return this.setFiltres(filtresAUpdate)
        .then(() => {
          this.resetAllSelects()
          this.loadGraphes()
        })
        .catch(() => this.erreur.updateFiltres = true)
        .finally(() => this.loading.updateFiltres = false)
    },
    loadGraphes () {
      this.loadRepartitionVenteAdherent()
      this.loadRepartitionVenteGroupe()
      this.loadRepartitionPrixContratMoyen()
      this.loadRepartitionPrixVenteMoyen()
      this.loadEvolutionRendements()
      this.loadEvolutionPrixContratGestionDeleguee()
    },
    loadRepartitionPrixVenteMoyen () {
      this.loading.repartitionPrixVenteMoyens = true
      this.erreur.repartitionPrixVenteMoyens = false

      const params = {
        codeGraine: this.codeGraineActive,
        anneeRecolte: this.anneeSelected,
        filtres: this.filtresAdherent
      }
      this.getPrixVenteMoyenComparaison(params)
        .catch(() => {
          this.erreur.repartitionPrixVenteMoyens = true
        })
        .finally(() => {
          this.loading.repartitionPrixVenteMoyens = false
        })
    },
    loadRepartitionPrixContratMoyen () {
      this.loading.repartitionPrixContratMoyens = true
      this.erreur.repartitionPrixContratMoyens = false

      const params = {
        codeGraineRs3: this.codeGraineActive,
        anneeRecolte: this.anneeSelected,
        filtres: this.filtresAdherent
      }
      this.getPrixContratMoyenComparaison(params)
        .catch(() => {
          this.erreur.repartitionPrixContratMoyens = true
        })
        .finally(() => {
          this.loading.repartitionPrixContratMoyens = false
        })
    },
    loadRepartitionVenteAdherent () {
      this.loading.repartitionAdherent = true
      this.erreur.repartitionAdherent = false

      const params = {
        codeGraineRs3: this.codeGraineActive,
        anneeRecolte: this.anneeRecolteSelected,
      }
      this.getRepartitionQuantiteCibleContratAdherent(params)
        .catch(() => {
          this.erreur.repartitionAdherent = true
        })
        .finally(() => {
          this.loading.repartitionAdherent = false
        })
    },
    loadRepartitionVenteGroupe () {
      this.loading.repartitionGroupe = true
      this.erreur.repartitionGroupe = false

      const params = {
        codeGraineRs3: this.codeGraineActive,
        anneeRecolte: this.anneeRecolteSelected,
        filtres: this.filtresAdherent
      }
      this.getRepartitionQuantiteCibleContratGroupe(params)
        .catch(() => {
          this.erreur.repartitionGroupe = true
        })
        .finally(() => {
          this.loading.repartitionGroupe = false
        })
    },
    loadEvolutionRendements () {
      this.erreur.evolutionRendement = false
      this.loading.evolutionRendement = true

      const params = {
        anneeRecolte: this.anneeRecolteSelected,
        codeGraineRs3: this.codeGraineActive,
        filtres: this.filtresAdherent
      }
      Promise.all([
        this.getEvolutionPrixContratNumtiers(params),
        this.getEvolutionPrixContratGroupe(params)
      ])
        .catch(() => {
          this.erreur.evolutionRendement = true
        })
        .finally(() => {
          this.loading.evolutionRendement = false
        })
    },
    loadEvolutionPrixContratGestionDeleguee () {
      this.erreur.evolutionPrixContratGestionDeleguee = false
      this.loading.evolutionPrixContratGestionDeleguee = true
      this.getEvolutionPrixContratGestionDeleguee(this.codeGraineActive)
        .catch(() => {
          this.erreur.evolutionPrixContratGestionDeleguee = true
        })
        .finally(() => {
          this.loading.evolutionPrixContratGestionDeleguee = false
        })
    },
    onPageOutilsAnalyse () {
      this.$router.push({ name: 'main.mes-outils-d-analyse' })
    },
    onAnyClickFiltres () {
      if (!this.abonnements.culturialAbonne) {
        this.isOpenModalInformationAbonnement = !this.isOpenModalInformationAbonnement
        this.incrementerAccesSouscriptionAbonnement('FILTRE_COMPARAISON')
      }
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
  background-color: #f1f2f5;
}
.bg-titre {
  height: 70px;
}
.prepend-icon {
  z-index: 100;
}
.asterix {
  font-size: 0.875rem;
  color: var(--gris-fonce);
}
.input-multiple {
  height: 60px !important;
  overflow-y: scroll;
  padding-top: 5px;
}
</style>
